<template>
    <div class="page-title">
        <h1> {{ main }}</h1>
        <h2>{{ sub }}</h2>
        <hr>
    </div>
</template>

<script>
export default {
    name: 'PageTitle',
    props: ['icon', 'main', 'sub']
}
</script>

<style>
    .page-title h1 {
        margin: 0px;
        padding-top: 15px;
        font-size: 1.5rem;
        color: #444444;
    }

    .page-title h2 {
        color: #777;
        margin-top: 5px;
        font-size: 1rem;
    }
</style>
